
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmRectifiedIec as ObiAlarmRectifiedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-rectified-iec.js';
 
 
 

 
 export const ObiAlarmRectifiedIec = createComponent({
   react: React,
   tagName: 'obi-alarm-rectified-iec',
   elementClass: ObiAlarmRectifiedIecElement,
   events: {
     
   }
  });
 
 